
import Api from "@/api/userService";
import snapList from "@/model/snapList";
import VinPram from "@/model/VinPram";
import { computed, defineComponent, PropType, ref } from "vue";
import useListDate from "../hook/UseListDate";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ReStart",
  props: {
    vin: {
      type: String as PropType<string>,
      required: true,
      defualt: "",
    },
  },
  setup(props, context) {
    const { t } = useI18n();
    const carVin = computed<string>(() => props.vin);
    const showSnapRecord = ref(false);
    const imgUrls = ref<Array<string>>();
    const showImg = ref(false);
    const catchTime = ref<string>();
    const snapRecordF = () => {
      showSnapRecord.value = true;
      getListData();
    };
    const closeSnapRecordF = () => {
      showSnapRecord.value = false;
    };
    const closeImgF = () => {
      showImg.value = false;
    };

    const getImgUrls = (imgs: Array<string>, snap_time: string) => {
      console.log(imgs);
      imgUrls.value = imgs;
      showImg.value = true;
      catchTime.value = snap_time;
    };
    const columns = [
      {
        title: t("serialnumber"),
        dataIndex: "index",
        key: "index",
        align: "left",
      },
      {
        title: "Vin",
        dataIndex: "vin",
        key: "vin",
        align: "left",
      },
      {
        title: t("capturetime"),
        dataIndex: "customer_name",
        key: "customer_name",
        align: "left",
      },
      {
        title: t("operate"),
        dataIndex: "vehicle_status_service",
        key: "vehicle_status_service",
        align: "center",
      },
    ];
    const {
      requestObj,
      dataList,
      totalNum,
      getListData,
      prevClick,
      nextClick,
      handleCurrentChange,
      setResultFaultF,
      handleSizeChange,
    } = useListDate<snapList, VinPram>(Api.getSnapRecord);

    requestObj.value.vin = carVin.value;

    return {
      snapRecordF,
      dataList,
      getImgUrls,
      requestObj,
      totalNum,
      getListData,
      prevClick,
      nextClick,
      handleCurrentChange,
      handleSizeChange,
      showSnapRecord,
      closeSnapRecordF,
      imgUrls,
      showImg,
      closeImgF,
      catchTime,
      columns,
      t,
    };
  },
});
